module.exports = __webpack_public_path__ + "static/img/p-30.8ce636b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-30.png
// module id = tUKl
// module chunks = 0